import { useId } from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";

type WithdrawalInputProps = {
  type: "number" | "text";
  label: string;
  value: number | string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  max?: number;
  span?: string;
  /** values the client used before, offered as they type */
  suggestions?: string[];
};

const WithdrawalInput: React.FC<WithdrawalInputProps> = ({
  type = "number",
  label,
  value,
  onChange,
  max,
  span,
  suggestions,
}) => {
  const { t } = useTranslation("app");
  const listId = useId();

  return (
    <div className="withdrawal-input-block">
      <label htmlFor={label}>{label}</label>

      <input
        id={label}
        type={type}
        value={value || ""}
        min={0}
        max={max || undefined}
        list={suggestions?.length ? listId : undefined}
        onChange={(e) => onChange(e)}
      />

      {suggestions?.length ? (
        <datalist id={listId}>
          {suggestions.map((s) => (
            <option key={s} value={s} />
          ))}
        </datalist>
      ) : null}

      {span && (
        <span>
          {t("available")}: {span}
        </span>
      )}
    </div>
  );
};

export default WithdrawalInput;
